import React from 'react';

import {
  resolveChartConfig,
  resolveLoaderConfig,
  resolveSummaryConfig,
} from '../../CustomBlocks/quiz/quizTypes';
import { EditorRoot } from '../slotBookingEditor/SlotBookingEditor.styles';
import LoadingAnalysisEditor from './LoadingAnalysisEditor';
import ProgressChartEditor from './ProgressChartEditor';
import { QuizEditorFields } from './quizEditor.styles';
import ResultSummaryEditor from './ResultSummaryEditor';

interface QuizBlockEditorProps {
  blockKey: string;
  value?: Record<string, any>;
  onChange: (next: Record<string, any>) => void;
}

/** Settings panel for the quiz blocks; each keeps its settings in `blockConfig`. */
const QuizBlockEditor: React.FC<QuizBlockEditorProps> = ({ blockKey, value, onChange }) => {
  const renderEditor = () => {
    if (blockKey === 'LoadingAnalysis') {
      const config = resolveLoaderConfig(value);
      return (
        <LoadingAnalysisEditor config={config} onChange={(patch) => onChange({ ...config, ...patch })} />
      );
    }
    if (blockKey === 'ResultSummary') {
      const config = resolveSummaryConfig(value);
      return (
        <ResultSummaryEditor config={config} onChange={(patch) => onChange({ ...config, ...patch })} />
      );
    }
    if (blockKey === 'ProgressChart') {
      const config = resolveChartConfig(value);
      return (
        <ProgressChartEditor config={config} onChange={(patch) => onChange({ ...config, ...patch })} />
      );
    }
    return null;
  };

  return (
    <EditorRoot>
      <QuizEditorFields>{renderEditor()}</QuizEditorFields>
    </EditorRoot>
  );
};

export default QuizBlockEditor;
